export function getSuperAdminMenu() {
  const currentClient = JSON.parse(localStorage.getItem('currentClient'))
  const canModuleDocuments = localStorage.getItem('canModuleDocuments') === 'true'
  const canModuleVacation = localStorage.getItem('canModuleVacation') === 'true'
  const menu = [
    {
      title: 'Parte de horas',
      route: 'partes',
      icon: 'ClockIcon',
    },
    ...((canModuleVacation && currentClient.vacation_module_enabled) ? [
      {
        title: 'Calendario',
        icon: 'CalendarIcon',
        route: 'vacations-calendar-admin',
      },
    ] : []),
    {
      title: 'Usuarios',
      route: 'users',
      icon: 'UsersIcon',
    },
    {
      title: 'Trazabilidad',
      route: 'traceabilities',
      icon: 'ActivityIcon',
    },
    ...((canModuleDocuments && currentClient.document_manager_enabled) ? [
      {
        title: 'Documentos',
        icon: 'FileTextIcon',
        children: [
          {
            title: 'Categorías',
            route: 'categoriesDocuments',
          },
          {
            title: 'Listado',
            route: 'adminDocuments',
          },
        ],
      },
    ] : []),
    ...((canModuleVacation && currentClient.vacation_module_enabled) ? [
      {
        title: 'Ausencias',
        icon: 'BriefcaseIcon',
        children: [
          {
            title: 'Pendientes',
            route: 'vacations-admin',
          },
        ],
      },
    ] : []),
    {
      title: 'Gestión',
      icon: 'SettingsIcon',
      children: [
        {
          title: 'Configuración',
          route: 'configuracion',
        },
        {
          title: 'Departamentos',
          route: 'departments',
        },
        {
          title: 'Política de registro horario',
          route: 'policy',
        },
      ],
    },
  ]
  return menu
}
